import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=77656801&scoped=true&"
import script from "./FeatureCard.vue?vue&type=script&lang=ts&"
export * from "./FeatureCard.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureCard.vue?vue&type=style&index=0&id=77656801&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77656801",
  null
  
)

export default component.exports